module.exports = "<vb-depot-stocktaking\r\n  [formHorizontal]=\"formHorizontal\"\r\n  [control]=\"control\"\r\n  [item]=\"item\">\r\n</vb-depot-stocktaking>\r\n\r\n<vb-stocktaking-form\r\n  [touchMode]=\"true\"\r\n  [formHorizontal]=\"formHorizontal\"\r\n  [control]=\"control\"\r\n  [item]=\"item\">\r\n</vb-stocktaking-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visbos-touch-client/ui/touch-stocktaking/touch-init-medicine-stocktaking/touch-init-medicine-stocktaking.component.html
// module id = ./src/app/visbos-touch-client/ui/touch-stocktaking/touch-init-medicine-stocktaking/touch-init-medicine-stocktaking.component.html
// module chunks = main